import React from 'react';
import Loadable from 'react-loadable';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

let PageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  PageComponent = require('./best_workplaces_for_innovators_application_page')
    .default;
}

export default function bwfiApplicationPage(store) {
  const routeConfig = {
    path: '/apply/best-workplaces-for-innovators',
    component() {
      if (PageComponent) {
        return <PageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: PageComponent ? PageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./best_workplaces_for_innovators_application_page').then(
        resp => {
          PageComponent = resp.default;
          routeConfig.loadData = PageComponent.loadData(store);

          return PageComponent;
        }
      );
    },
    chunk: 'bwfiApplicationPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
